import { Component, OnDestroy, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AppMainComponent } from 'src/app/app.main.component';
import { PaymentmethodService } from '../paymentmethod/paymentmethod.service';
import { SetupService } from '../setup.service';
import { AddYearPipe } from 'src/app/shared/pipes/add-year.pipe';
import { ObjectNames, Status, Severity, Answer } from '../../constants/constants';
import { TitleCasePipe } from '@angular/common';
import { Subscription } from 'rxjs';
import { CurrencySymbolPipe } from 'src/app/modules/shared/pipes/currency-symbol.pipe';

@Component({
  selector: 'app-paymentmethod',
  templateUrl: './paymentmethod.component.html',
  styleUrls: ['./paymentmethod.component.scss']
})
export class PaymentmethodComponent implements OnChanges {

  @Input() index: number = 1;
  @Input() length: number = 0;
  @Input() displayPaymentMethodAdd: boolean = false;
  @Output() closeDialog = new EventEmitter<boolean>();
  display: boolean = false;
  bankAccounts: any[] = [];
  dataMessage: string = 'Loading...';
  paymentMethodForm: FormGroup;
  addNewOptionForm: FormGroup;
  allPaymentMethods: any[];
  allMethodTypes: any[];
  isAddPaymentMethod: boolean = false;
  addEditPaymentMethodHeader: string;

  addEditOptionHeader: string;
  displayAddNewOption: boolean = false;
  payemntTermGroup: any;
  invalidData: boolean = false;
  invalidTypeData: boolean = false;
  statusConstants = Status;
  answertypeConstants = Answer;
  subscription: Subscription;

  constructor(private confirmationService: ConfirmationService, private messageService: MessageService, private paymentMethodService: PaymentmethodService,
    private fb: FormBuilder, private setupService: SetupService, private app: AppMainComponent, private yearPipe: AddYearPipe,
    private titlecasePipe: TitleCasePipe, private currencySymbol: CurrencySymbolPipe) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.index?.currentValue) {
      this.preparePaymentForm();
      this.prepareOptionForm();
      this.index = changes?.index?.currentValue;
      this.loadPaymentMethod(this.index);
      this.getPaymentTermGroup();
      this.loadBankAccounts();
    }
    if (changes?.displayPaymentMethodAdd?.currentValue) {
      this.display = changes?.displayPaymentMethodAdd?.currentValue;
      this.showAddPaymentMethod();
    }
  }

  loadBankAccounts() {
    this.paymentMethodService.getAllBankFinancialAccounts().subscribe((accounts) => {
      let data = [];
      for (let c of accounts) {
        let ChildData = [];
        for (let s of c.childAccounts) {
          let subData = [];
          for (let subb of s.childAccounts) {
            let childSubbData = [];
            for (let subChild of subb.childAccounts) {
              let fourthLevelData = [];
              for (let fourthLevel of subChild.childAccounts) {
                if (fourthLevel.statusId == 1) {
                  let eachFourthLevel = {
                    label: `${fourthLevel?.displayNumber || ''}-${fourthLevel.name} (${this.currencySymbol.transform(fourthLevel.balance.toFixed(this.length || 2))})`,
                    value: fourthLevel,
                    selectable: true,
                    children: []
                  };
                  fourthLevelData.push(eachFourthLevel);
                }
              }

              if (subChild.statusId == 1) {
                let eachSubChild = {
                  label: `${subChild?.displayNumber || ''}-${subChild.name} (${this.currencySymbol.transform(subChild.balance.toFixed(this.length || 2))})`,
                  value: subChild,
                  selectable: true,
                  children: fourthLevelData, // Assign fourth-level children
                };
                childSubbData.push(eachSubChild);
              }
            }

            let eachSub = {
              label: `${subb?.displayNumber || ''}-${subb.name} (${this.currencySymbol.transform(subb.balance.toFixed(this.length || 2))})`,
              selectable: true,
              value: subb,
              children: childSubbData, // Third-level children
            };
            subData.push(eachSub);
          }

          let eachSub = {
            label: `${s?.displayNumber || ''}-${s.name} (${this.currencySymbol.transform(s.balance.toFixed(this.length || 2))})`,
            value: s,
            selectable: true,
            children: subData // Second-level children
          };
          ChildData.push(eachSub);
        }

        let eachData = {
          label: `${c?.displayNumber || ''}-${c.name} (${this.currencySymbol.transform(c.balance.toFixed(this.length || 2))})`,
          value: c,
          selectable: true,
          children: ChildData // First-level children
        };
        data.push(eachData);
      }
      this.bankAccounts = data;
    });
  }


  preparePaymentForm() {
    this.paymentMethodForm = this.fb.group({
      id: [0],
      createdSource: [this.app.userIP],
      updatedSource: [this.app.userIP],
      createdBy: [this.app.userId],
      updatedBy: [this.app.userId],
      createdDate: [new Date().toISOString()],
      updatedDate: [new Date().toISOString()],
      organizationId: [this.app.companyId],
      name: ['', [Validators.required, Validators.pattern(/^(?!\s*$).+/)]],
      description: [''],
      statusId: [true],
      isValid: [true],
      validFromDate: [new Date().toISOString()],
      validToDate: [this.yearPipe.transform(new Date())],
      typeId: [this.allMethodTypes?.[0]],
      financialAccountId: [null, [Validators.required]]
    });
    if (this.index == 1) {
      this.paymentMethodForm.controls['financialAccountId'].clearValidators();
      this.paymentMethodForm.get('financialAccountId').updateValueAndValidity();
    }
  }

  prepareOptionForm() {
    this.addNewOptionForm = this.fb.group({
      id: [0],
      createdSource: [''],
      updatedSource: [''],
      createdBy: [''],
      updatedBy: [''],
      createdDate: [''],
      updatedDate: [''],
      name: ['', [Validators.required, Validators.pattern(/^(?!\s*$).+/)]],
      parentTypeId: [0],
      description: [''],
      groupId: [0],
      organizationId: [0],
      colorCodeId: [0],
      statusId: [Status.ACTIVE],
    });
  }

  loadPaymentMethod(index: number) {
    this.paymentMethodService.getPaymentMrthodList(index).subscribe((methods) => {
      this.allPaymentMethods = methods;
      if (this.allPaymentMethods?.length == 0) {
        this.dataMessage = 'No data found.';
      }
    })
  }

  getPaymentTermGroup() {
    this.paymentMethodService.getAllGroups().subscribe((groups) => {
      this.payemntTermGroup = groups.filter(group => group.name == ObjectNames.setupConstants.PaymentMethodName)[0];
      this.getAllPaymentTermTypes(this.payemntTermGroup.id);
    })
  }

  getAllPaymentTermTypes(id) {
    this.paymentMethodService.getAllPaymentMethodTypes(id).subscribe((types) => {
      this.allMethodTypes = types;
      this.paymentMethodForm.controls['typeId'].setValue(this.allMethodTypes[0]);
    })
  }

  showAddPaymentMethod() {
    if (this.index == 1) {
      this.addEditPaymentMethodHeader = ObjectNames.setupConstants.AddPaymentMethodTitle;
    } else {
      this.addEditPaymentMethodHeader = ObjectNames.setupConstants.AddVendorPaymentMethodTitle;
    }
    this.preparePaymentForm();
    this.isAddPaymentMethod = true;
    this.invalidData = false;
  }

  showEditPaymentMethod(payment) {
    this.isAddPaymentMethod = false;
    this.invalidData = false;
    if (this.index == 1) {
      this.addEditPaymentMethodHeader = ObjectNames.setupConstants.EditPaymentMethodTitle;
    } else {
      this.addEditPaymentMethodHeader = ObjectNames.setupConstants.EditVendorPaymentMethodTitle;
    }
    this.display = true;
    this.paymentMethodForm.patchValue(payment);
    const filteredMethodType = this.allMethodTypes?.filter(type => type.id == payment.typeId)[0];
    this.paymentMethodForm.controls['typeId'].setValue(filteredMethodType);
    this.paymentMethodForm.controls['statusId'].setValue(payment.statusId == Status.ACTIVE ? true : false);
    if (this.index == 3) {
      //For Parent Financial Account
      const filteredFinancialId = this.bankAccounts?.filter(finance => finance.value?.id == payment.financialAccountId)[0];
      this.paymentMethodForm.controls['financialAccountId'].setValue(filteredFinancialId);
      //For Child Financial Account
      this.bankAccounts?.forEach(finance => {
        const childAccount = finance.children?.filter(
          (child) => child.value?.id == payment.financialAccountId
        )[0];
        if (childAccount) {
          this.paymentMethodForm.controls['financialAccountId'].setValue(childAccount);
        }
      });
      //For Sub-Child Financial Account
      this.bankAccounts?.forEach(finance => {
        finance.children?.forEach(element => {
          const subChildAccount = element.children?.filter(
            (child) => child.value?.id == payment.financialAccountId
          )[0];
          if (subChildAccount) {
            this.paymentMethodForm.controls['financialAccountId'].setValue(subChildAccount);
          }
        });
      });
      //For forth level Financial Account
      this.bankAccounts.forEach(finance => {
        finance.children?.forEach(fnc => {
          fnc.children?.forEach(element => {
            const forthLevelChildAccount = element.children?.filter(
              (child) => child.value?.id == payment.financialAccountId
            )[0];
            if (forthLevelChildAccount) {
              this.paymentMethodForm.controls['financialAccountId'].setValue(forthLevelChildAccount);
            }
          });
        });
      });
    }
  }

  savePaymentMethod(value) {
    this.invalidData = false;
    value.statusId = value.statusId ? Status.ACTIVE : Status.INACTIVE;
    value.typeId = value.typeId?.id;
    if (this.index == 3) {
      value.financialAccountId = value.financialAccountId?.value?.id;
    } else {
      delete value["financialAccountId"];
    }
    const lowerCaseNames = [];
    if (this.isAddPaymentMethod) {
      for (let s of this.allPaymentMethods) {
        lowerCaseNames.push(s.name.toLowerCase().replace(/ /g, ''))
      }
      if (lowerCaseNames.indexOf(value.name.toLowerCase().replace(/ /g, '')) > -1) {
        this.invalidData = true;
      } else {
        this.paymentMethodService.addPaymentMethod(value, this.index).then(() => {
          this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: 'Payment Method Added successfully...' });
          this.loadPaymentMethod(this.index);
          this.display = false;
          this.closeDialog.emit();
        }).catch(() => {
          this.display = false;
          this.closeDialog.emit();
          this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: 'Error occurred while saving data...' });
        });
      }
    } else {
      const duplicateRecord = this.allPaymentMethods.find(depOb => depOb.name.toLowerCase().replace(/ /g, '') == value.name.toLowerCase().replace(/ /g, '') && depOb.id !== value.id)
      if (duplicateRecord) {
        this.invalidData = true;
      } else {
        this.invalidData = false;
        value.updatedBy = this.app.userId;
        value.updatedDate = new Date().toISOString();
        value.updatedSource = this.app.userIP;
        this.paymentMethodService.updatePaymentMethod(value, this.index).then(() => {
          this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: 'Payment Method Updated successfully...' });
          this.loadPaymentMethod(this.index);
          this.display = false;
          this.closeDialog.emit();
        }).catch(() => {
          this.display = false;
          this.closeDialog.emit();
          this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: 'Error occurred while saving data...' });
        });
      }

    }
  }

  checkPaymentMethodStatus() {
    if (!this.isAddPaymentMethod && !this.paymentMethodForm.controls['statusId'].value) {
      this.setupService.checkDeleteStatus(this.paymentMethodForm.controls['id'].value, 'paymentMethod').subscribe(check => {
        if (!check.item1) {
          return
        } else {
          this.paymentMethodForm.get("statusId").setValue(true);
          this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: `${check.item2}` });
        }
      })
    }
  }

  checkDeleteStatus(method) {
    this.setupService.checkDeleteStatus(method.id, 'paymentMethod', this.index).subscribe(check => {
      if (!check.item1) {
        this.deletePaymentMethod(method);
      } else {
        this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: `${check.item2}` });
      }
    })
  }

  deletePaymentMethod(payment) {
    this.confirmationService.confirm({
      message: 'Do you want to delete this Payment Method?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.paymentMethodService.deletePaymentMethod(payment.id, this.index).then(() => {
          this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: 'Deleted Successfully...' });
          const index = this.allPaymentMethods.indexOf(payment);
          this.allPaymentMethods.splice(index, 1);
        }).catch(() => {
          this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: 'Error occurred while deleting data...' });
        });
      },
      reject: () => {
      }
    });
  }


  addNewOption(value) {
    this.addEditOptionHeader = ObjectNames.setupConstants.AddPaymentTypeTitle;
    this.invalidTypeData = false;
    if (value.typeId.name == ObjectNames.setupConstants.AddPaymentTypeTitle) {
      this.addNewOptionForm = this.fb.group({
        id: [0],
        createdSource: [this.app.userIP],
        updatedSource: [this.app.userIP],
        createdBy: [this.app.userId],
        updatedBy: [this.app.userId],
        createdDate: [new Date().toISOString()],
        updatedDate: [new Date().toISOString()],
        organizationId: [this.app.companyId],
        name: ['', [Validators.required, Validators.pattern(/^(?!\s*$).+/)]],
        parentTypeId: [0],
        description: [''],
        groupId: [this.payemntTermGroup.id],
        colorCodeId: [0],
        statusId: [Status.ACTIVE],

      });
      this.displayAddNewOption = true;
    }
  }

  saveType(value) {
    value.description = value.name;
    const lowerCaseNames = [];
    for (let s of this.allMethodTypes) {
      lowerCaseNames.push(s.name.toLowerCase().replace(/ /g, ''))
    }
    if (lowerCaseNames.indexOf(value.name.toLowerCase().replace(/ /g, '')) > -1) {
      this.invalidTypeData = true;
    } else {
      this.paymentMethodService.addPaymentMethodTypes(value).then(() => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Payment Type Added successfully...' });
        this.getPaymentTermGroup();
        this.displayAddNewOption = false;
      }).catch(() => {
        this.displayAddNewOption = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred while saving data...' });
      });
    }
  }

  hideDialog() {
    this.paymentMethodForm.reset();
    this.closeDialog.emit();
  }


}
